import { Collapse } from 'antd';
import styled, { keyframes } from 'styled-components';

const fadeSlideIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(3px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const EventRecordWrapper = styled.div`
  animation: ${fadeSlideIn} 120ms ease-out;

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;

export const ErrorEvent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: 10px;
  gap: 10px;
`;

export const DebugWrapper = styled.div`
  margin-top: 8px;
  font-size: 12px;
  color: #666;
  background-color: #f5f5f5;
  padding: 8px;
  border-radius: 4px;
`;

export const ScrollWrapper = styled.div`
  flex: 1;
  overflow-y: auto;
  padding-left: 10%;
  padding-right: 10%;
  padding-top: 10px;
  position: relative;
  border-bottom: 1px solid #c9cbcd;
`;

export const UserText = styled.div`
  padding: 8px 15px;
  border-radius: 8px;
  font-size: 16px;
  background-color: #dbdedf70;
  border: 1px solid #ccc;
  display: flex;
  gap: 5px;
  justify-content: center;
  align-items: center;
`;

export const AgentText = styled.div`
  width: 100%;
  overflow-x: auto;
  padding: 0;
  display: flex;
  gap: 5px;
  font-size: 16px;
  color: #4a4a4a;

  table {
    border-collapse: collapse;
    width: 100%;
    overflow-x: auto;
    display: block;
    margin-bottom: 1em;
  }

  thead {
    background-color: white;
    text-align: left;

    tr {
      th {
        font-weight: 500;
      }
    }
  }

  th,
  td {
    border: 1px solid #ddd;
    padding: 8px;
    background-color: white;
  }
`;

export const AgentFooter = styled.div`
  display: flex;
  position: relative;
  top: 0;
  border-top: 1px solid #a3a1a1;
  padding-top: 10px;
  margin-bottom: 25px;
  align-items: center;
`;

export const StyledCollapse = styled(Collapse)`
  .ant-collapse-content-box {
    background-color: #00000014;
    border-radius: 5px;
  }
`;
